import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { AmazonContextProvider } from "./Contexts/AmazonContext";
import { PostHogProvider } from 'posthog-js/react';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./index.css";

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
};

ReactDOM.render(
  <div>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={posthogOptions}
    >
      <AmazonContextProvider>
        <App />
      </AmazonContextProvider>
    </PostHogProvider>
  </div>,
  document.getElementById("root")
);

// Immediately unregister any existing service worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
